import InfiniteGrid, {GridLayout} from '@egjs/infinitegrid';
import './kakao.min.js';

var ig = new InfiniteGrid('#chat-container', {
    horizontal: false,
    isConstantSize: true,
});

ig.setLayout(GridLayout, {
    margin:20,
    align:'justify'
});
ig.layout();

window.addEventListener('resize', function(e){
    ig.layout();
});

Kakao.init('4b997691bda6d3b126d0cb0ff282da6a');

window.addKakaoChannel = () => {
    Kakao.Channel.addChannel({
        channelPublicId: '_SpSQxb'
    });
};

function makeCard(tpl, d) {
    const {id, username, message, img_url, created_at} = d;
    tpl.querySelector('.item').id = `chat-card-${id}`;

    if (!img_url) {
        tpl.querySelector('.card-img-link').remove();
    } else {
        tpl.querySelector('.card-img-link').href = img_url;
        tpl.querySelector('.card-img-link').dataset.lightbox = 'gallery';
        tpl.querySelector('.card-img').src = img_url;
    }

    tpl.querySelector('.card-text').innerHTML = message;
    tpl.querySelector('.username').textContent = username;
    tpl.querySelector('.created_at').textContent = moment(created_at)
        .format('YYYY-MM-DD a hh:mm');
    if (tpl.querySelector('.card-footer .card-del-trigger')) {
        tpl.querySelector('.card-del-trigger').dataset.chatId = id;
        tpl.querySelector('.card-del-trigger')
            .setAttribute('onclick', 'deleteChatCard(this)');
    }
    return tpl;
}

window.deleteChatCard = (obj) => {
    if (!confirm('카드를 삭제할까요?')) return false;
    const id = obj.dataset.chatId;
    const endpoint = `/api/kakao/${id}`;
    axios.delete(endpoint)
        .then(r => {
            ig.remove(obj.closest('.item'));
            ig.layout();
        })
        .catch(err => {
            console.log(err.response ? err.response : err);
            alert('오류 발생! 관리자에게 문의바랍니다.');
        });
};

async function fetchChats(endpoint = null) {
    try {
        if (!endpoint) {
            endpoint = '/api/kakao?page=1';
        }
        const r = await axios.get(endpoint);
        const {
            current_page,
            first_page_url,
            from,
            next_page_url,
            path,
            per_page,
            prev_page_url,
            to,
            data
        } = r.data;

        const container = document.getElementById('chat-container');
        container.innerHTML = '';
        ig.clear();

        const items = [];
        if (data.length === 0) {
            const tpl = document.getElementById('chat-card-empty-tpl')
                .content
                .cloneNode(true);
            items.push(tpl.firstElementChild);
        } else {
            data.forEach(d => {
                const tpl = document.getElementById('chat-card-tpl')
                    .content
                    .cloneNode(true);

                const card = makeCard(tpl, d);
                items.push(card.firstElementChild);
            });
        }

        ig.append(items);
        ig.layout();

        const pageLinks = document.querySelectorAll('#chat-paginate .page-link');
        pageLinks.forEach(el => {
            const pageItem = el.closest('.page-item');
            if (pageItem.classList.contains('first')) {
                el.href = first_page_url;
            } else if (pageItem.classList.contains('prev')) {
                el.href = prev_page_url ? prev_page_url : 'javascript:;';
                if (!prev_page_url) {
                    pageItem.classList.add('disabled');
                    el.setAttribute('aria-disabled', 'true');
                }
            } else if (pageItem.classList.contains('next')) {
                el.href = next_page_url ? next_page_url : 'javascript:;';
                if (!next_page_url) {
                    pageItem.classList.add('disabled');
                    el.setAttribute('aria-disabled', 'true');
                }
            }
        });

        $(container.querySelectorAll('.chat-card a[data-lightbox="gallery"]'))
            .magnificPopup({
                type: 'image',
                gallery: {
                    enabled: true
                }
            });

        feather.replace();

    } catch (err) {
        console.log(err.response ? err.response : err);
    }
}

fetchChats();

const pageLinks = document.querySelector('#chat-paginate');
pageLinks.addEventListener('click', e => {
    e.preventDefault();
    const el = e.target;
    if (el.classList && el.classList.contains('page-link')) {
        el.onclick = fetchChats(el.href);
    }
});

const chatForm = document.getElementById('chat-form');
chatForm.addEventListener('submit', e => {
    e.preventDefault();
    const spinner = document.getElementById('spinner-container');
    spinner.classList.toggle('hide');
    e.target.querySelector('button[type="submit"]').disabled = true;
    const fd = new FormData(e.target);
    const config = {'Content-Type': 'multipart/form-data'};
    axios.post(e.target.action, fd, config)
        .then(r => {
            const tpl = document.getElementById('chat-card-tpl')
                .content
                .cloneNode(true);
            const card = makeCard(tpl, r.data);
            const container = document.getElementById('chat-container');
            if (container.querySelector('.empty-col')) {
                container.querySelector('.empty-col')
                    .remove();
            }

            const items = [];
            items.push(card.firstElementChild);
            if (container.childElementCount > 0) {
                ig.prepend(items);
            } else {
                ig.append(items);
            }
            ig.layout();

            $(container.querySelectorAll('.chat-card a[data-lightbox="gallery"]'))
                .magnificPopup({
                    type: 'image',
                    gallery: {
                        enabled: true
                    }
                });

            feather.replace();

            spinner.classList.toggle('hide');
            e.target.querySelector('button[type="submit"]').disabled = false;
            e.target.reset();

            const chatFormContainer = document.getElementById('chat-form-container');
            $(chatFormContainer)
                .collapse('hide');

        })
        .catch(err => {
            console.log(err.response ? err.response : err);
            alert('오류 발생! 관리자에게 문의바랍니다.');
        });
});

const photoTrigger = document.getElementById('photo-trigger');
photoTrigger.addEventListener('click', e => {
    chatForm.img_path.click();
});

chatForm.img_path.addEventListener('change', e => {
    const feedback = chatForm.querySelector('.feedback');
    if (e.target.value.length > 0) {
        feedback.innerText = e.target.value;
        feedback.style.display = '';
    } else {
        feedback.innerText = '';
    }
});

const chatFormContainer = $('#chat-form-container');
chatFormContainer.on('shown.bs.collapse', function () {
    chatForm.username.focus();
});

if (location.hash && location.hash === '#write') {
    chatFormContainer.collapse('show');
}
